module.exports = __webpack_public_path__ + "static/img/articlecargo1.c935765.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlecargo1.png
// module id = RWOz
// module chunks = 1